import { 
    MAIN_MENU_ROUTE, COURSES_STORE_ROUTE, COURSES_DETAIL_ROUTE, 
    COURSES_OPTIONS_ROUTE, COURSES_CART_ROUTE, MY_COURSES_ROUTE,
    VIDEO_CARD_ROUTE, LESSON_ROUTE, COURSES_SUBJECT_COURSES, 
    COURSES_THEMES, COURSES_THEMES_ID
} from "../constants/constants";

import MainMenu from "../pages/MainMenu/MainMenu";
import CourseAll from "../pages/CourseAll/CourseAll";
import CourseStoreDetail from '../pages/CourseStoreDetail/CourseStoreDetail';
import CourseStoreOptions from "../pages/CourseStoreOptions/CourseStoreOptions";
import CourseCart from "../pages/CourseCart/CourseCart";
import MyCourses from "../pages/MyCourses/MyCourses";
import VideoCard from "../pages/VideoCard/VideoCard";
import Courses from "../pages/MyCourses/components/Courses/Courses";
import Paragraphs from "../pages/MyCourses/components/paragraphs/Paragraphs";
import Themes from "../pages/MyCourses/components/homework/Themes";
import StudentStream from "../pages/StudentStream/StudentStream";
import Homework from "../pages/MyCourses/components/homework/Homework";


const studentRoutes = [
    {
      path: MAIN_MENU_ROUTE,
      Component: MainMenu,
    },
    {
      path: 'themes/:id/homework',
      Component: Homework,
    },
    {
      path: 'themes/:id/stream',
      Component: StudentStream,
    },
    {
      path: COURSES_STORE_ROUTE,
      Component: CourseAll,
    },
    {
      path: COURSES_DETAIL_ROUTE + '/:id',
      Component: CourseStoreDetail,
    },
    {
      path: COURSES_OPTIONS_ROUTE + '/:id',
      Component: CourseStoreOptions,
    },
    {
      path: COURSES_CART_ROUTE,
      Component: CourseCart,
    },
    {
      path: MY_COURSES_ROUTE,
      Component: MyCourses,
    },
    {
      path: VIDEO_CARD_ROUTE,
      Component: VideoCard,
    },
    {
      path: COURSES_SUBJECT_COURSES,
      Component: Courses,
    },
    {
      path: COURSES_THEMES,
      Component: Paragraphs,
    },
    {
      path: COURSES_THEMES_ID,
      Component: Themes,
    },
  ];

export default studentRoutes